// extracted by mini-css-extract-plugin
export default {"wrapper":"Projects_wrapper__FkXSy","header":"Projects_header__eIoR-","headerWrapper":"Projects_headerWrapper__H+BKr"};